import { computed, inject, onBeforeUnmount, provide, shallowReactive, unref } from 'vue';

export const SHOP_MANAGEMENT_SHORTCUT_SCOPE_KEY = Symbol('shopManagementShortcutScope');

// The shell owns the policy so page-specific preferences also reach its siblings.
export const provideShopManagementShortcutScope = () => {
  const scopes = shallowReactive(new Map());
  const enabled = computed(() =>
    Array.from(scopes.values()).every(
      (source) => (typeof source === 'function' ? source() : unref(source)) !== false,
    ),
  );
  const policy = {
    enabled,
    register(source) {
      const owner = Symbol('shortcutScope');
      scopes.set(owner, source);
      return () => scopes.delete(owner);
    },
  };

  provide(SHOP_MANAGEMENT_SHORTCUT_SCOPE_KEY, policy);
  return policy;
};

export const useShopManagementShortcutScope = (enabled) => {
  const policy = inject(SHOP_MANAGEMENT_SHORTCUT_SCOPE_KEY, null);
  const unregister = policy?.register(enabled);
  onBeforeUnmount(() => unregister?.());
};
